import { createFileRoute, redirect } from '@tanstack/react-router'
import { GlobalSearchParams } from 'routes/(global_search_params)/-searchParams'
import {
  createReportingReportSearch,
  reportingReportSearchParams,
} from 'routes/reporting/-searchParams'
import { Route as NewRoute } from 'routes/reporting/details'
import z from 'zod'

const legacyReportSearchSchema = reportingReportSearchParams.pick({
  templateId: true,
  metadataEntryId: true,
  section: true,
})

export const Route = createFileRoute(
  '/reporting/(deprecated_routes)/$siteID/$reportID'
)({
  validateSearch: legacyReportSearchSchema,
  beforeLoad: ({ params }) => {
    const { reportID, siteID } = params

    throw redirect({
      to: NewRoute.to,
      search: (
        prev: Record<string, unknown> &
          z.infer<typeof legacyReportSearchSchema> &
          GlobalSearchParams
      ) =>
        createReportingReportSearch({
          orgId: prev.orgId,
          reportId: reportID,
          siteId: siteID,
          templateId: prev.templateId,
          metadataEntryId: prev.metadataEntryId,
          section: prev.section,
        }),
      replace: true,
    })
  },
})
